<template>
  <div class="flex justify-start items-center">
    <img
      class="svg-icon"
      :src="luggage ? '/icons/suitcase-yes.svg' : '/icons/suitcase-no.svg'"
    />
    <div class="flex flex-col ml-4 luggage-message">
      <span :data-i18n="luggage ? 'charterLuggageIncluded' : 'charterLuggageNotIncluded'">
        {{ $t(luggage ? 'charterLuggageIncluded' : 'charterLuggageNotIncluded') }}
      </span>
      <slot />
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'CharterFlightLuggage',

  props: {
    luggage: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.luggage-message {
  font-size: 0.85rem;
  color: theme('colors.text-gray');
}
</style>
